import { render, staticRenderFns } from "./CampaignHeader.vue?vue&type=template&id=564ec63a&scoped=true&"
import script from "./CampaignHeader.vue?vue&type=script&lang=js&"
export * from "./CampaignHeader.vue?vue&type=script&lang=js&"
import style0 from "./CampaignHeader.vue?vue&type=style&index=0&id=564ec63a&lang=scss&scoped=true&"
import style1 from "./CampaignHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ec63a",
  null
  
)

export default component.exports